(function () {
    'use strict';

    angular
        .module('app')
        .controller('EditPasswordController', EditPasswordController);

    EditPasswordController.$inject = ['$window', '$modalInstance', 'authentication', 'isDismissible', 'config'];

    function EditPasswordController($window, $modalInstance, authentication, isDismissible, config) {
        var vm = this;

        vm.onSubmit = onSubmit;
        vm.isDismissible = isDismissible;
        vm.passwordRequirements = null;

        activate();

        function activate() {
            config.get().then(function (configData) {
                vm.passwordRequirements = configData.passwordRequirements;
            });
        }

        function onSubmit() {
            authentication.changeLoginPassword({
                password: vm.newPassword
            }).then($modalInstance.close).catch(function (error) {
                vm.formError = error;
            });
        }
    }
})();